import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the window-keyed spans query, so widening the window re-keys THIS match and not the page.
export const Route = createFileRoute('/_app/admin/traces_/$traceId/_spans')({
  loaderDeps: ({ search }) => ({ at: search.at, wide: search.wide }),
  context: ({ params, deps }) => ({
    traceQueryOptions: trpc.admin.getTrace.queryOptions({
      traceId: params.traceId,
      at: deps.at,
      wide: deps.wide || undefined,
    }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.traceQueryOptions).catch(noop)
  },
})
